
class a11yHelper{
    constructor(){

    }

    init(){
        document.addEventListener('keydown', function ( evt ) {
            if ( evt.keyCode === 27 ) { // ESC
                if(document.getElementById("slideout-backdrop").classList.contains("open")){
                    document.getElementById("slideout-backdrop").classList.remove("open");
                    document.getElementById("main").focus();
                }
            }
        });
    }

    focus(ele){

        target = ele.dataset.target.replace("#", "");
        let $target = document.getElementById(target);
        // console.log($target);
        // $target.style.display = "block";
        // $target.style.opacity = 1;
        ele.addEventListener('keydown', function(evt){
            if(evt.keyCode == 13 || evt.keyCode == 32) {
                evt.preventDefault();
                ele.click();
                setTimeout(function(){
                    // console.log($target.querySelectorAll("ul > li:first-child a")[0]);
                    $target.querySelectorAll("ul > li:first-child a")[0].focus();
                    // $target.focus();
                }, 200);
            }
        });
    }
}
window.app.add('a11y', new a11yHelper());